import React from "react";
import "./footerStyles.css";

export default function Footer() {
  return (
    <>
      <div className="footerClass">
        <p>
          IMPORTANT: *With investment, your capital is at risk. The value of
          your portfolio can go down as well as up and you may get back less
          than you invest. Investing / Trading is subject to market risk.
        </p>
        <p>
          Please ensure you carefully read the Risk Disclosure Document as
          prescribed by SEBI.
        </p>
        <p>Version 1.0</p>
        <h6>Copyright © 2023 Robotic Solutions </h6>
      </div>
    </>
  );
}
